import React, { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Menu from '@material-ui/core/Menu';
import LanguageIcon from '@material-ui/icons/Language';

import { switchLanguage } from 'actions/App';
import IntlMessages from 'util/IntlMessages';
import { useLocalizedMessage } from 'util/useLocalizedMessage';
import LanguageSwitcher from './index';

const LanguageButton = () => {
  const dispatch = useDispatch();
  const t = useLocalizedMessage();

  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = useCallback((event) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const handleSwitchLanguage = useCallback((language) => {
    if (language && language.locale) {
      dispatch(switchLanguage(language));
    }
    setAnchorEl(null);
  }, [dispatch]);

  return (
    <>
      <Tooltip title={<IntlMessages id="sidebar.account.changeLanguage" />} placement="bottom">
        <IconButton
          color="inherit"
          onClick={handleOpen}
          aria-label={t('sidebar.account.changeLanguage')}
          style={{ padding: 8 }}
        >
          <LanguageIcon />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <LanguageSwitcher
          switchLanguage={handleSwitchLanguage}
          handleRequestClose={handleClose}
        />
      </Menu>
    </>
  );
};

export default LanguageButton;
